/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReadinessIssueDTO { 
    severity?: ReadinessIssueDTOSeverityEnum;
    code?: string;
    params?: Array<any>;
    area?: ReadinessIssueDTOAreaEnum;
    pointer?: string;
}
export enum ReadinessIssueDTOSeverityEnum {
    ERROR = 'ERROR',
    WARNING = 'WARNING'
};
export enum ReadinessIssueDTOAreaEnum {
    POLICY = 'POLICY',
    ATTRIBUTI = 'ATTRIBUTI',
    TEMPLATE = 'TEMPLATE',
    SCORING = 'SCORING',
    GRADUATORIA = 'GRADUATORIA',
    SERVIZIO = 'SERVIZIO'
};



